import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import store from "@/store";
import { fetchTopAreaPlaceList } from "@/api/adapter.api";

export function showI18nTitle(i18nObj: PortalAdapterApi.I18nObject): string | undefined {
  const lang = store.state.data.language as "ja-JP" | "zh-TW" | "zh-CN" | "en-US" | "ko-KR";
  console.log(`saved lang: ${lang}`);
  let lang2 = lang.replace("-", "_") as "ja_JP" | "zh_TW" | "zh_CN" | "en_US" | "ko_KR";
  console.log(`lang2 = ${lang2}`);
  if (lang2 === undefined) lang2 = "ja_JP";
  const feedbackLang = i18nObj.fallbackLanguage as "ja_JP" | "zh_TW" | "zh_CN" | "en_US" | "ko_KR";
  console.log(`result: ${i18nObj.languageList[lang2]}`);
  return i18nObj.languageList[lang2] === undefined ? i18nObj.languageList[feedbackLang] : i18nObj.languageList[lang2];
}

export async function getAreaListForRereshUI(
  countryName?: string,
  mapsMapType?: string
): Promise<PortalAdapterApi.ResponseGetTopAreaList> {
  // load area again
  if (countryName === undefined) {
    countryName = store.getters["data/getSelectedCountry"];
  }
  if (countryName === undefined) return [];
  const areaList: PortalAdapterApi.ResponseGetTopAreaList = await getTopAreaListByCountryName(
    countryName,
    mapsMapType
  ).catch(() => {
    console.error(`get genre error`);
    return [];
  });
  return areaList;
}

export async function getTopAreaListByCountryName(
  countryName: string,
  mapsMapType?: string
): Promise<PortalAdapterApi.ResponseGetTopAreaList> {
  if (countryName === undefined) return [];
  return await fetchTopAreaPlaceList(countryName, mapsMapType).catch(() => {
    console.error(`get genre error`);
    return [];
  });
}

export function findSubarea(areaList: PortalAdapterApi.ResponseGetTopAreaList): PortalAdapterApi.TopArea | undefined {
  const targetSubarea: undefined | PortalAdapterApi.ResponseGetTopArea = areaList.find(
    (area: PortalAdapterApi.ResponseGetTopArea) => {
      return area.areaList.find(
        (subarea: PortalAdapterApi.TopArea) => subarea.areaName === store.state.data.selectedTopPlace.areaName
      );
    }
  );
  const subarea: PortalAdapterApi.TopArea | undefined =
    targetSubarea === undefined
      ? undefined
      : targetSubarea.areaList.find(area => area.areaName === store.state.data.selectedTopPlace.areaName);
  return subarea;
}
